import _implicitStylesheets from "./searchInput.css";
import _implicitScopedStylesheets from "./searchInput.scoped.css?scoped=true";
import _axIcon from "ax/icon";
import {freezeTemplate, registerTemplate} from "lwc";
const stc0 = {
  "search-icon": true
};
const stc1 = {
  "search-input": true
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {ncls: api_normalize_class_name, c: api_custom_element, b: api_bind, h: api_element} = $api;
  const {_m0} = $ctx;
  return [api_element("div", {
    className: api_normalize_class_name($cmp.controlClass),
    key: 0
  }, [api_custom_element("ax-icon", _axIcon, {
    classMap: stc0,
    props: {
      "icon": "search",
      "size": $cmp.iconSize,
      "iconDescription": "",
      "ariaHidden": "true"
    },
    key: 1
  }), api_element("input", {
    classMap: stc1,
    attrs: {
      "type": "text",
      "placeholder": $cmp.placeholder,
      "aria-label": $cmp.placeholder,
      "disabled": $cmp.disabled ? "" : null,
      "aria-disabled": $cmp.disabled,
      "data-testid": "search-input"
    },
    props: {
      "value": $cmp.value
    },
    key: 2,
    on: {
      "input": _m0 || ($ctx._m0 = api_bind($cmp.handleInput))
    }
  })])];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-3kb5u8b50ff";
tmpl.legacyStylesheetToken = "undefined-_searchInput";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
